import { range } from "lodash";
import { getWidth } from "../common";

const columns = 11;
export default range(columns).map(current => {
  const field = `switch_detection_${current + 1}`;
  return {
    field,
    label: field,
    width: getWidth(columns),
    isSortable: false,
    isCSV: true
  };
});
